import { memo, useMemo } from 'react'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck, faTimes } from '@fortawesome/pro-solid-svg-icons'

import { faCommentCheck, faCommentSlash } from '@fortawesome/pro-light-svg-icons'

import { Table, theme } from '@domain-group/suit-theme'

import { formatDate } from '@domain-group/javascript-utils'

import type { ApiLogModel } from '@models/types'

import FailedApiLogActions from './FailedApiLogActions'

type DateObject = {
  created?: {
    date_time?: string,
  },
  updated?: {
    date_time?: string,
  },
}

const buildColumns = () => [
  {
    title: 'Date',
    dataKey: 'dates',
    cellProps: {
      width: 200,
    },
    render: (dates: DateObject) => {
      const createdDate = dates?.created?.date_time ?? ''
      const formattedDate = formatDate(createdDate, 'dd/MM/yyyy HH:mm', "ccc d LLL 'at' t")

      return formattedDate
    },
  },
  {
    title: 'API Type',
    dataKey: 'api_type',
    cellProps: {
      textAlign: 'center',
    },
  },
  {
    title: 'Event',
    dataKey: 'event',
  },
  {
    title: 'Entity',
    dataKey: 'entity_type',
    render: (entityType: string, apiLog: ApiLogModel) => `${entityType} #${apiLog.entity_id}`,
  },
  {
    title: 'Success',
    dataKey: 'success',
    cellProps: {
      textAlign: 'center',
    },
    render: (success: boolean) => (
      <FontAwesomeIcon icon={success ? faCheck : faTimes} />
    ),
  },
  {
    title: 'Notes',
    dataKey: 'notes',
    cellProps: {
      textAlign: 'center',
    },
    render: (notes: string) => (
      <FontAwesomeIcon
        color={notes ? theme?.colors?.blue : theme?.colors?.faintGrey}
        icon={notes ? faCommentCheck : faCommentSlash}
      />
    ),
  },
  {
    title: 'Actions',
    dataKey: 'id',
    cellProps: {
      textAlign: 'center',
    },
    render: (id: number) => <FailedApiLogActions apiLog={{ id }} />,
  },
]

interface FailedApiLogsTableProps {
  failedApiLogs: ApiLogModel[],
}

const FailedApiLogsTable = (props: FailedApiLogsTableProps) => {
  const { failedApiLogs } = props

  const memoColumns = useMemo(() => buildColumns(), [failedApiLogs.length])

  return (
    <Table
      boxProps={{ border: 'none', maxHeight: 800, overflowY: 'auto' }}
      // @ts-expect-error TS2322
      columns={memoColumns}
      // @ts-expect-error TS2322
      data={failedApiLogs}
      stickyHeader
    />
  )
}

export default memo(FailedApiLogsTable)
